import { createApp, h } from 'vue';
import LoadingModal from './LoadingModal.vue';

/**
 * 一定時間スリープするPromiseを返す
 * @param ms - スリープする秒数
 */
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const SHOW_DELAY_MS = 200;
const MIN_VISIBLE_MS = 500;

/**
 * ローディングモーダルを表示し、Promise の完了を待つ
 * @param task - 実行する Promise タスク
 * @param title - モーダルタイトル
 * @param description - モーダル説明文
 * @returns Promise<void>
 */
export async function waitLoading<T>(task: Promise<T>, title?: string, description?: string): Promise<T | undefined> {
  let result: T | undefined;

  let app: ReturnType<typeof createApp> | undefined;
  let container: HTMLDivElement | undefined;

  let modalShown = false;
  let shownAt = 0;

  const showTimer = window.setTimeout(() => {
    modalShown = true;
    shownAt = Date.now();

    container = document.createElement('div');
    document.body.appendChild(container);

    app = createApp({
      // eslint-disable-next-line jsdoc/require-jsdoc
      render() {
        return h(LoadingModal, {
          title,
          description,
        });
      },
    });

    app.mount(container);
  }, SHOW_DELAY_MS);

  try {
    // Promise タスクを実行
    result = await task;
    return result;
  } catch (e) {
    console.error(e);
    return undefined;
  } finally {
    window.clearTimeout(showTimer);

    if (modalShown) {
      const visibleTime = Date.now() - shownAt;
      const remain = Math.max(0, MIN_VISIBLE_MS - visibleTime);

      if (remain > 0) await sleep(remain);
    }
    // モーダルのクリーンアップ
    if (app && container) {
      app.unmount();
      document.body.removeChild(container);
    }
  }
}
